<template>
  <div id="app">
    <!-- <v-header v-if="isRouterAlive"></v-header> -->
    <PersonalNav v-if="isRouterAlive" />
    <!-- <TypeNav :obj="TypeRoute"/> -->
    <router-view></router-view>
    <VFoot :phone="phone" :address="address" />
    <FloatBlock style="right: 0px; bottom: calc(50% - 125px); z-index: 1999">
      <div class="float-btns">
        <!-- 客服 -->
        <div v-if="false" class="item" @click="
          toLink(
            'https://cschat.antcloud.com.cn/index.htm?tntInstId=ib4_U5x3&scene=SCE01222806',
            true
          )
        ">
          <el-image src="static/images/FloatBtns/customer-service.png"></el-image>
          <div class="desc">客服</div>
        </div>
        <!-- QQ -->
        <el-popover trigger="hover" placement="left" width="160">
          <div class="hover-block">
            <div>客服QQ</div>
            <div class="number">
              1150332391
              <a href="javascript:void(0);"
                style="color: #048bff; font-size: 12px; text-decoration: underline; padding-left: 0.5rem;"
                @click="copyClick('1150332391')">复制</a>
            </div>
          </div>
          <div slot="reference" class="item">
            <el-image src="static/images/FloatBtns/QQ.png"></el-image>
            <div class="desc">客服</div>
          </div>
        </el-popover>
        <!-- 电话 -->
        <el-popover trigger="hover" placement="left" width="160">
          <div class="hover-block">
            <div>联系电话</div>
            <div class="number">{{ phone }}</div>
          </div>
          <div slot="reference" class="item">
            <el-image src="static/images/FloatBtns/tele-phone.png"></el-image>
            <div class="desc">电话</div>
          </div>
        </el-popover>
        <!-- 微信 -->
        <el-popover trigger="hover" placement="left" width="160">
          <div class="hover-block" style="height: 130px">
            <el-image style="width: 90px; height: 90px; margin: 5px 20px" src="static/images/ty-qc.jpg"></el-image>
            <div style="text-align: center; font-size: 18px">关注我们</div>
          </div>
          <div class="item" slot="reference">
            <el-image src="static/images/FloatBtns/we-char.png"></el-image>
            <div class="desc">微信</div>
          </div>
        </el-popover>
        <!-- 常见问题 -->
        <div class="item" style="border-bottom: none;" @click="toLink('/agreement/commonProblem', true)">
          <el-image src="static/images/FloatBtns/common-problem.png"></el-image>
          <div class="desc">常见问题</div>
        </div>
      </div>
    </FloatBlock>
  </div>
</template>

<script>
/* eslint-disable */
import { StoreKey } from "@/utils/config.js";
import { copyText } from "@/utils/tool";
import { getCanvasData } from "@/api/indexpage.js";
import VHeader from "@/components/base/v-header";
import VFoot from "@/components/base/v-foot";
import PersonalNav from "@/components/common/TopPersonalNav";
import TypeNav from "@/components/common/TopTypeNav";
import FloatBlock from "@/components/common/FloatBlock";

export default {
  name: "App",
  components: { VHeader, VFoot, PersonalNav, TypeNav, FloatBlock },
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      phone: '',
      address: '',
      // TypeRoute: {},
    };
  },
  watch: {
    $route(to, from) {
      if (to.name !== from.name) {
        this.reload();
      }
    },
  },
  created() {
    this.getCanvas();
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload", () => {
      localStorage.setItem(StoreKey, JSON.stringify(this.$store.state));
    });
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem(StoreKey) &&
      this.$store.replaceState(
        Object.assign(
          this.$store.state,
          JSON.parse(localStorage.getItem(StoreKey))
        )
      );
  },
  methods: {
    async getCanvas() {
      var res = await getCanvasData({ terminal: "4" });
      if (!res.json) {
        return;
      }
      var canvasData = JSON.parse(res.json);
      canvasData = canvasData
        .map((item) => {
          if (item.type === "NavType") {
            return item;
          }
          if (item.type === "Footer") {
            return item;
          }
        })
        .filter((r) => r);
      // this.TypeRoute = this.giveTypeRes("NavType", canvasData);
      let footerData = this.giveTypeRes("Footer", canvasData);
      var data = footerData.componentContent.publicList
      for (var i = 0; i < data.length; i++) {
        if (data[i].title === '客服电话') {
          this.phone = data[i].des
        }
        if (data[i].title === '营业时间') {
          this.address = data[i].des
        }
        // if (data[i].title === '微信公众号') {
        //   this.img.des = data[i].des
        //   this.img.pic = data[i].pic || 'static/images/ty-qc.jpg'
        // }
        // if (data[i].title === '小程序码') {
        //   this.img2.des = data[i].des
        //   this.img2.pic = data[i].pic
        // }
      }
    },
    giveTypeRes(type, data) {
      var result;
      for (var key in data) {
        if (data[key].type === type) {
          result = data[key];
        }
      }
      return result;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    toLink(link, isNewWindows = false) {
      let url = null;
      if (link.indexOf("http") > -1) {
        url = link;
      } else {
        let temp = this.$router.resolve({ path: link });
        url = temp.href;
      }
      if (isNewWindows) {
        window.open(url, "_blank");
      } else {
        location.href = url;
      }
    },
    copyClick(txt) {
      copyText(txt || '').then(() => {
        this.$message.success('复制成功')
      }).catch(err => {
        this.$message.warning('复制失败')
      });
    }
  },
};
</script>

<style lang="scss">
#app {
  background-color: #f6f6f8;
  padding-top: 61px;

  $floatBtnWidth: 45px;

  .float-btns {
    width: $floatBtnWidth;
    color: #fff;
    background-color: #2088d1;
    border-radius: 6px;

    .item {
      width: $floatBtnWidth;
      // height: 60px;
      padding: 5px;
      border-bottom: solid 1px #fff;
      cursor: pointer;

      .el-image {
        width: 25px;
        height: 25px;
        margin: 0 5px;
      }

      .desc {
        font-size: 12px;
        font-weight: 400;
        line-height: 12px;
        color: #ffffff;
        text-align: center;
      }
    }
  }
}

.hover-block {
  width: 150px;
  font-size: 18px;

  .number {
    color: #003d88;
    // cursor: pointer;
  }
}

.el-loading-mask {
  .el-loading-spinner {
    .path {
      stroke: #333333;
    }
  }
}

// loading
.el-loading-spinner {

  i,
  .el-loading-text {
    font-size: 18px;
    color: #333333;
  }
}

.pagination {
  padding: 30px 0;
  max-width: 1170px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/App.vue